<template>
  <div id="app">
    <div>
      <table>
        <tr>
          <td>Fabric Width (in)</td>
          <td>
            <input
            type="number"
              name="boltWidth"
              id=""
              v-model.number="boltWidth"
              @change="update()"
            >
          </td>
        </tr>
        <tr>
          <td>Repeat (in)</td>
          <td>
            <input
              type="number"
              name="repeat"
              min="0"
              v-model.number="repeat"
              @change="update()"
            />
          </td>
        </tr>

        <tr>
          <td>Rod Width (in)</td>
          <td>
            <input
              type="number"
              name="rodWidth"
              v-model.number="rodWidth"
              @change="update"
              min="0"
            />
          </td>
        </tr>
        <tr>
          <td>Left Return (in)</td>
          <td>
            <input
              type="number"
              name="leftReturn"
              v-model.number="leftReturn"
              @change="update"
              min="0"
            />
          </td>
        </tr>
        <tr>
          <td>Right Return (in)</td>
          <td>
            <input
              type="number"
              name="rightReturn"
              v-model.number="rightReturn"
              @change="update"
              min="0"
            />
          </td>
        </tr>
        <tr>
          <td>Overlap (in)</td>
          <td>
            <input
              type="number"
              name="overlap"
              v-model.number="overlap"
              @change="update"
              min="0"
            />
          </td>
        </tr>

        <tr>
          <td>Fullness</td>
          <td>
            <select
              name="fullness"
              id=""
              v-model.number="fullness"
              @change="update()"
            >
              <option v-for="item in fullnessOptions" :value="item" :key="item">
                {{ item }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Lining</td>
          <td>
            <select name="" id="" v-model="lining" @change="update()">
              <option :value="false">Unlined</option>
              <option :value="true">Lined</option>
            </select>
          </td>
        </tr>

        <tr>
          <td>Finished Length (in)</td>
          <td>
            <input
              type="number"
              name="finishedLength"
              v-model.number="finishedLength"
              min="0"
              max="180"
              @change="update()"
            />
          </td>
        </tr>
        <tr>
          <td>Total Widths</td>
          <td>
            <span class="bold">{{ this.totalWidths }}</span>
          </td>
        </tr>
        <tr>
          <td>Finished Width (in)</td>
          <td>
            <span class="bold">{{ this.finishedWidth }}</span>
          </td>
        </tr>
        <tr>
          <td>Cut Length (in)</td>
          <td class="bold">{{ this.cutLength }}</td>
        </tr>
        <tr>
          <td>Extra for Repeat (in)</td>
          <td class="bold">{{ this.fabricNeededForRepeat }}</td>
        </tr>
        <tr>
          <td>Total Length (in)</td>
          <td class="bold">{{ this.totalLength }}</td>
        </tr>
        <tr>
          <td>
            <span class="bold">Yardage Required</span>
          </td>

          <td>
            <span class="bold">{{ this.COMyardage }}</span>
          </td>
        </tr>
        <tr>
          <td><a href="#" @click="reset">reset</a></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { masterFunction } from "./masterFunction.js";

export default {
  name: "App",
  data() {
    return {
      pattern: null,
      color: null,
      source: null,
      description: null,
      boltWidth: 54,
      repeat: 0,
      repeatSurcharge: null,
      priceCode: 5,
      fabricPrice: null,
      pricePoint: null,
      panelOrPair: "panel",
      quantity: 1,
      rodWidth: 0,
      leftReturn: 0,
      rightReturn: 0,
      overlap: 0,
      COM: false,
      finishedWidth: null,
      fullness: 2,
      fullnessOptions: [1.5, 2, 2.25, 2.5, 3],
      fullnessMessage: "",
      totalWidths: null,
      finishedLength: 0,
      cutLength: 0,
      shirr: null,
      headingSize: null,
      rodPocketSize: null,
      lining: false,
      liningType: "RoyalSateen",
      liningColor: null,
      interlining: false,
      interliningColor: null,
      interliningCost: 0,
      pinSetting: "regular",
      COMyardage: null,
      fabricNeededForRepeat: 0,
      baseCost: 0,
      totalLength: 0,
      pleatType: null,
      pleatMessage: null,
      pleatCost: 0,
      trimming: {
        horizontal: {
          included: false,
          COM: false,
          pattern: null,
          price: null,
          labor: null,
          yardageRequired: null,
          cost: null,
          total: null,
        },
        vertical: {
          included: false,
          COM: false,
          pattern: null,
          price: null,
          labor: null,
          yardageRequired: null,
          cost: null,
          total: null,
        },
        total: {
          cost: null,
        },
      },
      unitCost: 0,
    };
  },
  methods: {
    masterFunction,
    update() {
      //send the entire object to masterFunction
      var result = masterFunction(this.$data);

      //map result data back to view
      this.finishedWidth = result.finishedWidth;
      this.totalWidths = result.totalWidths;
      this.cutLength = result.cutLength;
      this.fabricNeededForRepeat = result.fabricNeededForRepeat;
      this.totalLength = result.totalLength;
      this.COMyardage = result.COMyardage;
    },
    reset() {
      this.boltWidth = 54;
      this.rodWidth = 0;
      this.leftReturn = 0;
      this.rightReturn = 0;
      this.overlap = 0;
      this.finishedLength = 0;
      this.repeat = 0;
      this.update();
    },
  },
  mounted() {
    this.update();
  },
};
</script>

<style>
.flex-container {
  display: flex;
  flex-wrap: nowrap;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 0px;
}
html,
input,
select {
  font-size: 1em;
}

.bold {
  font-weight: bold;
}

input,
select,
textarea {
  border: 1px solid #ccc;
  padding: 2px;
  border-radius: 4px;
  width: 100px;
  font-weight: bold;
}

td {
  text-align: left;
  padding: 0px 40px 12px 0px;
  outline: 0px red solid;
}
</style>